module.exports = __webpack_public_path__ + "static/img/Blog Post.78ec4c98.svg";